<div class="cb-margin flex-col">
    @if (standardPlanssLoaded && addressRegionsLoaded) {
        <cb-standard-plan-search
            [(standardPlans)]="standardPlans"
            [addressRegions]="addressRegions"></cb-standard-plan-search>
    }
    @if (standardPlanssLoaded && addressRegionsLoaded && stylesLoaded) {
        <cb-standard-plan-card
            [standardPlans]="standardPlans"
            [addressRegions]="addressRegions"
            [styles]="styles"></cb-standard-plan-card>
    }
    @if (!standardPlanssLoaded || !addressRegionsLoaded || !stylesLoaded) {
        <cb-loading-spinner
            message="Loading standard plans"></cb-loading-spinner>
    }
    @if (standardPlanssLoaded && standardPlans.length < 1) {
        <cb-info-message message="There are no Standard Plans found"
        >
        </cb-info-message>
    }
</div>
